// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kv-0";
export var fileCarousel = "_kv-2";
export var removeFileButton = "_kv-1";